import React from 'react'

const Modal = ({ title, children, closeModal, saveModal, noBtn, deleteMode, deleteItem, resetModal }) => {
  return (
    <div className="custom_modal_container">
      <div className="modal_inner">
        <div className="close" onClick={ closeModal }>✕</div>
        <h4 className="modal_title">{ title }</h4>
        <div className="modal_main">
          { children }
        </div>
        {
          noBtn
            ? null
            : deleteMode
              ? (
                <div className="modal_btn flex">
                  <button className="btn reverse_red small_btn" onClick={ resetModal }>キャンセル</button>
                  <button className="btn red small_btn" onClick={ deleteItem }>削除</button>
                </div>
              )
              : (
                <div className="modal_btn flex">
                  <button className="btn reverse_red small_btn" onClick={ closeModal }>キャンセル</button>
                  <button className="btn reverse_primary small_btn" onClick={ saveModal }>保存</button>
                </div>
              )
        }
      </div>
    </div>
  )
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/_common/Modal.js